__turbopack_context__.v({
  "applyBtn": "CDedicatedJobOffers-module__C27JuG__applyBtn",
  "applyWrap": "CDedicatedJobOffers-module__C27JuG__applyWrap",
  "body": "CDedicatedJobOffers-module__C27JuG__body",
  "card": "CDedicatedJobOffers-module__C27JuG__card",
  "cardDesc": "CDedicatedJobOffers-module__C27JuG__cardDesc",
  "cardTitle": "CDedicatedJobOffers-module__C27JuG__cardTitle",
  "list": "CDedicatedJobOffers-module__C27JuG__list",
  "pill": "CDedicatedJobOffers-module__C27JuG__pill",
  "pillList": "CDedicatedJobOffers-module__C27JuG__pillList",
  "root": "CDedicatedJobOffers-module__C27JuG__root",
  "tech": "CDedicatedJobOffers-module__C27JuG__tech",
  "techList": "CDedicatedJobOffers-module__C27JuG__techList",
});
